import React from 'react';
import { AnnotationPanelWrap, PanelHeader, IconGrid, IconCell } from './Annotation.styles';
import { getIconsByCategory, ANNOTATION_CATEGORIES } from './AnnotationIcons';

const AnnotationPanel = ({ activeCategory, pendingType, onSelectIcon, onClose }) => {
  if (!activeCategory) return null;

  const catDef = ANNOTATION_CATEGORIES.find(c => c.key === activeCategory);
  const icons = getIconsByCategory(activeCategory);

  return (
    <AnnotationPanelWrap>
      <PanelHeader>
        <span>{catDef?.label || activeCategory}</span>
        <button onClick={onClose} title="Close">×</button>
      </PanelHeader>
      <IconGrid>
        {icons.map(({ key, label, svg }) => (
          <IconCell
            key={key}
            active={pendingType === key}
            onClick={() => onSelectIcon(key)}
            title={label}
          >
            {/* Safe: svg is a static string from ICON_DEFS, never from user input */}
            <span dangerouslySetInnerHTML={{ __html: svg }} />
            <span>{label}</span>
          </IconCell>
        ))}
      </IconGrid>
    </AnnotationPanelWrap>
  );
};

export default AnnotationPanel;
